import { permissionObj } from '../../../Helpers/permission';
import Step1Details from '../../Dashboard/Company/Employees/EnrollmentSteps/Step1Details';
import Step2OtherDetails from '../../Dashboard/Company/Employees/EnrollmentSteps/Step2OtherDetails';
import UploadImageModal from '../../../components/UploadImageModal';
import ImagePreview from '../../../components/ImagePreview';
import { EditIcon } from '../../../components/buttons/IconButtons';
import ButtonAction from '../../../components/buttons/ButtonAction';
import ProfileProviderApp from './Functionality/ProfileProviderApp';
import CustomModal from '../../../components/Modal/CustomModal';
import CopySecretModal from '../../Dashboard/Company/Employees/Modal/CopySecretModal';
import routes from '../../../Routes/routes';
import CustomDescriptionLabel from '../../../components/CustomDescriptionLabel';
import { FILE_TYPE } from '../../../Helpers/fileType';
import CustomCard from '../../../components/CustomCard';
import CustomChip from '../../../components/CustomChip';
import { colors } from '../../../enums/colors';
import CustomTabContainer from '../../../components/CustomTabContainer';
import CustomTab from '../../../components/CustomTab';
import { PROFILE_TABS, PROFILE_VIEW } from './model';
import Badges from './Subcomponents/Badges';
import { getFullName } from '../../../Apis/functions';
import { userType } from './../../../enums/userTypeEnum';
import {STATUS_MODEL} from "../../../enums/statusEnum";

const ProfileProvider = () => {
    const {
        t,
        permission,
        navigate,
        DEV,
        statusId,
        headersList,
        disable,
        userFull,
        setUserFull,
        modalShow,
        setModalShow,
        showModal,
        setShowModal,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        emptyFields,
        extra,
        contractorId,
        supplierId,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        isValidDocumentId,
        handleUnlinkDevice,
        handleFormChangeUserData,
        handleSubmit,
        photoPicker,
        setPhotoPicker,
        RandomProfile,
        previewImage,
        subView,
        handleSubViewChange,
    } = ProfileProviderApp();
    // Redirects to forbidden page if the user is not in DEV mode, lacks read permission,
    // and is not associated with a contractor or supplier.
    if (!DEV && !permission?.includes(permissionObj.WEB_PROFILE_READ) && contractorId === null && supplierId === null)
        navigate(routes.forbidden);

    return (
        <>
            <CustomCard classCard='card-border-8px overflow-hidden' classContent='p-0'>
                <RandomProfile className='w-100 p-0' />
                <div className='ml-58px'>
                    <ImagePreview
                        className={'mt-negative-30px'}
                        preview={previewImage}
                        click={
                            DEV ||
                            permission?.includes(permissionObj.WEB_PROFILE_UPDATE) ||
                            contractorId !== null ||
                            supplierId !== null
                                ? () => setShowModal(true)
                                : false
                        }
                    />

                    <div className='mt-3 ml-3'>
                        <p className='ibl-h3 font-color-text-950 ibl-font-w-500'>
                            {getFullName(userFull.name, userFull.lastName, userFull.secondLastName)}
                        </p>
                        <CustomChip
                            legend={t(userType[userFull.userTypeId])}
                            background={colors.secondary100}
                            fontColor={colors.secondary700}
                            borderColor={colors.secondary150}
                            variant='compact'
                        />
                    </div>
                </div>

                <CustomCard classCard={'card-border-8px m-3'} classContent={'p-0'}>
                    <div className='d-flex align-items-center w-100'>
                        <div className='m-3'>
                            <CustomTabContainer
                                activeTab={subView}
                                setActiveTab={handleSubViewChange}
                                className='rounded-top border-0 px-0'
                            >
                                {PROFILE_TABS.filter((item) => {
                                    if (item.key === PROFILE_VIEW.BADGES) {
                                        return contractorId && statusId !== STATUS_MODEL.TO_APPROVE_DOCUMENT;
                                    }

                                    if (item.key === PROFILE_VIEW.EXTRA_DATA) {
                                        return extra;
                                    }
                                    return true;
                                }).map((item) => (
                                    <CustomTab
                                        key={item.key}
                                        id={item.key}
                                        title={t(item.translation)}
                                        label={t(item.translation)}
                                        icon={item.icon}
                                        isSelected={subView === item.key}
                                        selected={subView === item.key}
                                        onClick={() => handleSubViewChange(item.key)}
                                    />
                                ))}
                            </CustomTabContainer>
                        </div>

                        {subView !== PROFILE_VIEW.BADGES &&
                            (DEV ||
                                permission?.includes(permissionObj.WEB_PROFILE_UPDATE) ||
                                contractorId !== null ||
                                supplierId !== null) && (
                                <div className='ms-auto mr-3'>
                                    <ButtonAction
                                        id='btn_pp_update_data'
                                        name='update'
                                        className='btn-icon-edit'
                                        Icon={EditIcon}
                                        onClick={handleSubmit}
                                    />
                                </div>
                            )}
                    </div>{' '}
                    <div className={'border-bottom-shades-300'} />
                    <div className='mt-3'>
                        {subView === PROFILE_VIEW.USER_DATA && (
                            <Step1Details
                                userData={userFull}
                                onChange={handleFormChangeUserData}
                                emptyFields={emptyFields}
                                isValidEmail={isValidEmail}
                                isValidDocumentId={isValidDocumentId}
                                isValidPhoneNumber={isValidPhoneNumber}
                                isValidDob={isValidDob}
                                setIsValidDob={setIsValidDob}
                                setModalShow={setModalShow}
                                disable={disable}
                                sectionProfile={true}
                            />
                        )}
                        {subView === PROFILE_VIEW.EXTRA_DATA && extra === true && (
                            <Step2OtherDetails
                                extraData={userFull}
                                onChange={handleFormChangeUserData}
                                setExtraData={setUserFull}
                                headersList={headersList}
                                profile={true}
                                disable={disable}
                            />
                        )}
                        {subView === PROFILE_VIEW.BADGES && contractorId !== null && <Badges />}
                    </div>
                </CustomCard>
            </CustomCard>
            {modalShow && (
                <CustomModal
                    title={t('unlink_device')}
                    size='lg'
                    buttonConfirm='confirm'
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    onConfirm={() => {
                        handleUnlinkDevice();
                    }}
                >
                    <div className={'col-12 center-text'}>
                        <CustomDescriptionLabel trans={t('unlink_confirmation_msg')} />
                    </div>
                </CustomModal>
            )}
            <UploadImageModal
                title={t('update_photography')}
                show={showModal}
                onHide={() => setShowModal(false)}
                photoPicker={photoPicker}
                setPhotoPicker={setPhotoPicker}
                validateFace={true}
                fileType={FILE_TYPE.IMAGE_FACE_VALIDATION}
            />

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUserFull}
                onHide={() => {}}
                closeText={'close'}
            />
        </>
    );
};

export default ProfileProvider;
